import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPlusLegacy = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6 0H5.4v5.4H0v1.2h5.4V12h1.2V6.6H12V5.4H6.6V0Z"
          fill="currentColor"
        />
      </svg>
    </IconBase>
  );
};

SvgPlusLegacy.displayName = 'SvgPlusLegacy';
export default SvgPlusLegacy;
